import { render, staticRenderFns } from "./SubCategoryCard.vue?vue&type=template&id=2b410ff0&scoped=true"
import script from "./SubCategoryCard.vue?vue&type=script&lang=js"
export * from "./SubCategoryCard.vue?vue&type=script&lang=js"
import style0 from "./SubCategoryCard.vue?vue&type=style&index=0&id=2b410ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b410ff0",
  null
  
)

export default component.exports